<script>
import { Tabs, Tab, Cell, Image } from 'vant'
import BottomToolbar from '@/components/org/BottomToolbar'
import DateTimeFunc from '@/tbs/util/DateTimeFunc'
import { QNImageUtil } from '@/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-match-signup-payment-detail',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-tabs': Tabs,
        'van-tab': Tab,
        'van-cell': Cell,
        'van-image': Image,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            match: {},
            matchRule: {},
            matchSignup: {},
            matchSignupConfig: {},
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        matchStartDateField() {
            if (this.match.startDate) {
                return DateTimeFunc.formatDate(this.match.startDate, 'yyyy.MM.dd')
            }
            return ''
        },
        matchAreaField() {
            if (this.match.area) {
                let field = ''
                const areaArr = this.match.area.split(' ')
                if (areaArr.length == 3) {
                    field = areaArr[1] + ' ' + areaArr[2]
                }
                else {
                    if (areaArr.length == 2) {
                        if (areaArr[0] == areaArr[1]) {
                            field = areaArr[0]
                        }
                        else {
                            field = areaArr[0] + ' ' + areaArr[1]
                        }
                    }
                    else {
                        field = areaArr[0]
                    }
                }
                return field
            }
            return ''
        },
        numSelectionField() {
            if (this.locale.localeProp && this.matchRule.numSelection) {
                return this.locale.localeProp('match-number-selection', {num: this.matchRule.numSelection})
            }
            return ''
        },
        periodTimeField() {
            if (this.locale.localeProp && this.matchRule.periodTime) {
                return this.matchRule.periodTime + this.locale.localeProp('period-time-placeholder')
            }
            return ''
        },
        substitutionField() {
            let field = ''
            if (this.locale.localeProp && this.matchRule.substitutionType) {
                if (this.matchRule.substitutionType == '3') {
                    field += this.locale.localeProp('substitution-type-option-3')
                }
                else if (this.matchRule.substitutionType == '1') {
                    if (this.matchRule.restrictionNumType == '1') {
                        field += this.locale.localeProp('substitution-type1-restriction-type1', {num: this.matchRule.restrictionNum})
                    }
                    else if (this.matchRule.restrictionNumType == '2') {
                        field += this.locale.localeProp('substitution-type1-restriction-type2', {num: this.matchRule.restrictionNum})
                    }
                    field += this.locale.localeProp('comma')
                    if (this.matchRule.isSubstitutionOn) {
                        field += this.locale.localeProp('substitution-on-yes')
                    }
                    else {
                        field += this.locale.localeProp('substitution-on-no')
                    }
                }
                else if (this.matchRule.substitutionType == '2') {
                    if (this.matchRule.restrictionTimesType == '1') {
                        field += this.locale.localeProp('substitution-type1-restriction-type1', {num: this.matchRule.restrictionTimes})
                    }
                    else if (this.matchRule.restrictionTimesType == '2') {
                        field += this.locale.localeProp('substitution-type1-restriction-type2', {num: this.matchRule.restrictionTimes})
                    }
                    field += this.locale.localeProp('comma')
                    if (this.matchRule.isSubstitutionHalfCount) {
                        field += this.locale.localeProp('substitution-half-count-yes')
                    }
                    else {
                        field += this.locale.localeProp('substitution-half-count-no')
                    }
                    field += this.locale.localeProp('comma')
                    if (this.matchRule.isSubstitutionOn) {
                        field += this.locale.localeProp('substitution-on-yes')
                    }
                    else {
                        field += this.locale.localeProp('substitution-on-no')
                    }
                }
                else if (this.matchRule.substitutionType == '4') {
                    if (this.matchRule.substitutionTotalType == '1') {
                        field += this.locale.localeProp('substitution-type1-restriction-type1', {num: this.matchRule.substitutionTotal})
                    }
                    else if (this.matchRule.substitutionTotalType == '2') {
                        field += this.locale.localeProp('substitution-type1-restriction-type2', {num: this.matchRule.substitutionTotal})
                    }
                    field += this.locale.localeProp('comma')
                    field += this.locale.localeProp('substitution-once-num', {num: this.matchRule.substitutionOnceNum})
                    field += this.locale.localeProp('comma')
                    if (this.matchRule.isSubstitutionHalfCount) {
                        field += this.locale.localeProp('substitution-half-count-yes')
                    }
                    else {
                        field += this.locale.localeProp('substitution-half-count-no')
                    }
                    field += this.locale.localeProp('comma')
                    if (this.matchRule.isSubstitutionOn) {
                        field += this.locale.localeProp('substitution-on-yes')
                    }
                    else {
                        field += this.locale.localeProp('substitution-on-no')
                    }
                }
            }
            return field
        },
        matchTypeField() {
            if (this.locale.localeProp && this.matchRule.type) {
                if (this.matchRule.type == '1' && this.matchRule.specType == '1') {
                    return this.locale.localeProp('match-spec-type-option-1') + this.locale.localeProp('match-type-option-1')
                }
                else if (this.matchRule.type == '1' && this.matchRule.specType == '2') {
                    return this.locale.localeProp('match-spec-type-option-2') + this.locale.localeProp('match-type-option-1')
                }
                else if (this.matchRule.type == '2') {
                    return this.locale.localeProp('match-spec-type-option-' + this.matchRule.specType)
                }
            }
            return ''
        },
        teamTotalField() {
            if (this.locale.localeProp && this.matchSignup.teamTotal) {
                return this.matchSignup.teamTotal + this.locale.localeProp('team-unit')
            }
            return ''
        },
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onEditBtnClick() {
            console.log('onEditBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgEditMatchSignupPayment',
                    params: { id: this.matchSignup.id }
                }
            })
        },
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h, mode) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h, mode)
            }
			else {
                return null
            }
		},
        /**
         * @private
         * Format the date object as the yyyy.MM.dd hh:mm format string.
         * @param dateTime The date object.
         * @return The formatted date time string.
         */
        formatDateTime(dateTime) {
            return DateTimeFunc.formatDate(dateTime, 'yyyy.MM.dd hh:mm')
        },
    },
}
</script>

<template>
    <div class="match-signup-payment-detail">
        <div class="match bg-white">
            <div class="match-logo text-center">
                <img 
                    class="corner-round"
                    :src="adjustImageSize(match.logoUrl, 120, 120)" 
                    style="width: 60px; height: 60px;"
                />
            </div>
            <div class="match-name text-center">
                <span class="main-text">{{ match.name }}</span>
            </div>
            <div class="match-start-date text-center">
                <span class="minor-text minor-color">{{ matchStartDateField }}</span>
            </div>
            <div class="match-area text-center t-outer-margin minor-text minor-color">
                <span class="bg-minor u-narrow-padding corner-round-lg">
                <span><i class="iconfont iconfont-icon-address minor-icon"/></span><span class="l-inner-margin">{{ matchAreaField }}</span>
                </span>
            </div>
        </div>
        <div class="match-signup bg-white t-outer-margin u-wide-padding">
            <div class="signup-name b-outer-margin">
                <span class="main-text">{{ matchSignup.name }}</span>
            </div>
            <div v-if="matchSignup.startDateTime" class="normal-text minor-color b-inner-margin">
                <span><i class="iconfont iconfont-icon-time main-icon"/></span>
                <span class="l-inner-margin">{{ locale['match-signup-start-time-label'] }}</span>
                <span class="l-outer-margin">{{ formatDateTime(matchSignup.startDateTime) }}</span>
            </div>
            <div class="normal-text minor-color b-inner-margin">
                <span><i class="iconfont iconfont-icon-time main-icon"/></span>
                <span class="l-inner-margin">{{ locale['match-signup-end-time-label'] }}</span>
                <span class="l-outer-margin">{{ formatDateTime(matchSignup.endDateTime) }}</span>
            </div>
            <div class="normal-text minor-color">
                <span><i class="iconfont iconfont-icon-team main-icon"/></span>
                <span class="l-inner-margin">{{ locale['match-signup-team-total-label'] }}</span>
                <span class="l-outer-margin">{{ matchSignup.teamTotal }}</span>
            </div>
        </div>
        <div class="tab-container">
            <van-tabs 
                scrollspy sticky
                offset-top="43">
                <van-tab :title="locale['match-signup-info']">
                    <div class="bg-white">
                        <div class="u-wide-padding">
                            <span class="main-text">{{ matchSignup.description }}</span>
                        </div>
                        <div class="u-inner-padding b-outer-margin block-item">
                            <div class="title-wrapper">
                                <div class="bg-minor title vertical-center">
                                    <div class="title-text">
                                        <span class="main-text">{{ locale['match-rule'] }}</span>
                                    </div>
                                </div>
                                <div class="border-grid">
                                    <van-cell
                                        :title="locale['match-num-selection-label']"
                                        :value="numSelectionField"
                                    />
                                    <van-cell
                                        :title="locale['period-time-label']"
                                        :value="periodTimeField"
                                    />
                                    <van-cell
                                        :title="locale['substitution-type-label']"
                                        :value="substitutionField"
                                    />
                                    <van-cell
                                        :title="locale['match-type-label']"
                                        :value="matchTypeField"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="u-inner-padding b-outer-margin block-item b-outer-padding">
                            <div class="title-wrapper">
                                <div class="bg-minor title vertical-center">
                                    <div class="title-text">
                                        <span class="main-text">{{ locale['match-signup-requirements'] }}</span>
                                    </div>
                                </div>
                                <div class="border-grid">
                                    <van-cell
                                        :title="locale['match-signup-team-total']"
                                        :value="teamTotalField"
                                    />
                                    <van-cell
                                        :title="locale['team-number']"
                                        :value="matchSignupConfig.teamNumLabel"
                                    />
                                    <van-cell
                                        class="tags-cell"
                                        :title="locale['match-team-data-collect']"
                                    >
                                        <template #default>
                                            <div class="lhr">
                                                <div 
                                                    v-for="item in matchSignupConfig.teamSignupItems" 
                                                    :key="item.value"
                                                    class="inline-block r-outer-margin"
                                                >
                                                    <div class="bg-primary corner-round-sm b-narrow-margin">
                                                        <div class="u-narrow-padding">
                                                        <span class="minor-text color-white">{{ item.label }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </van-cell>
                                    <van-cell
                                        class="tags-cell"
                                        :title="locale['match-member-data-collect']"
                                    >
                                        <template #default>
                                            <div class="lhr">
                                                <div 
                                                    v-for="item in matchSignupConfig.memberSignupItems" 
                                                    :key="item.value"
                                                    class="inline-block r-outer-margin"
                                                >
                                                    <div class="bg-primary corner-round-sm b-narrow-margin">
                                                        <div class="u-narrow-padding">
                                                        <span class="minor-text color-white">{{ item.label }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </van-cell>
                                    <van-cell 
                                        v-if="matchSignupConfig.isStaffOn"
                                        :title="locale['staff-number']"
                                        :value="matchSignupConfig.staffNumLabel"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </van-tab>
                <van-tab :title="locale['match-signup-intro']">
                    <div class="bg-white b-outer-padding">
                        <div class="u-wide-padding">
                            <span class="main-text">{{ locale['match-signup-intro'] }}</span>
                        </div>
                        <div v-if="matchSignup.imageUrls" class="u-inner-padding lh0">
                            <van-image 
                                v-for="item in matchSignup.imageUrls"
                                :key="item"
                                :src="adjustImageSize(item, 686, 0, 0)"
                                center
                                width="100%"
                            />
                        </div>
                        <div v-else class="text-center b-wide-margin">
                            <span class="minor-text minor-color">{{ locale['match-signup-photo-empty-hint'] }}</span>
                        </div>
                    </div>
                </van-tab>
            </van-tabs>
        </div>
        <bottom-toolbar 
            type="button" 
            :mainButtonLabel="locale['edit']"
            @click-main-button="onEditBtnClick"
        />
    </div>
</template>

<style scoped>
.match-logo {
    padding-top: 30px;
}
.match-name {
    padding: 15px 60px 10px 60px;
}
.match-area {
    padding-bottom: 25px;
}
.title {
    width: 341px;
    height: 30px;
    border-radius: 8px 8px 0px 0px;
}
.title-text {
    padding: 6px 16px;
}
.title-wrapper {
    border: 1px solid #F2F3F5;
    border-radius: 8px;
}
.tags-cell {
    padding-right: 6px !important;
}
.tags-cell .van-cell__title {
    flex: 1;
}
.tags-cell .van-cell__value {
    flex: 3;
}
</style>